export default{
  client: (state) => state.client,
  clientsLoaded: (state) => state.clientsLoaded,
  totalMoney: (state) => state.totalMoney
}



// WEBPACK FOOTER //
// ./src/components/client/store/getters.js